var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInitiate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4295",
    "data-name": "Group 4295",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11949",
    "data-name": "Path 11949",
    d: "M16,10a3,3,0,1,0,3,3,3.015,3.015,0,0,0-3-3Zm0,2a1,1,0,1,1-1,1,.985.985,0,0,1,1-1Z",
    fill: "#174a84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11950",
    "data-name": "Path 11950",
    d: "M16.023,2a1,1,0,0,0-.523.133A14.088,14.088,0,0,0,8,15v1.586L2.295,22.293A1,1,0,0,0,3,24H29a1,1,0,0,0,.707-1.707L24,16.586V15A14.089,14.089,0,0,0,16.5,2.133,1,1,0,0,0,16.023,2ZM16,4.209C19.1,6.116,22,9.036,22,15v7H10V15c0-5.965,2.9-8.884,6-10.791ZM8,19.414V22H5.415Zm16,0L26.585,22H24Zm-9,7.6v1.972a1,1,0,1,0,2,0V27.014a1,1,0,1,0-2,0Zm-4,0v1.972a1,1,0,1,0,2,0V27.014a1,1,0,1,0-2,0Zm8,0v1.972a1,1,0,1,0,2,0V27.014a1,1,0,1,0-2,0Z",
    fill: "#174a84"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitiate);
export default __webpack_public_path__ + "static/media/initiate.e7df07ca70d6507aa2619827f1c20741.svg";
export { ForwardRef as ReactComponent };